import { useEffect, useRef } from "react";
import { Card, CardBody, Col } from "reactstrap";
import Sortable from "sortablejs";
import { LI } from "../../../AbstractElements";
import { DisabledLists } from "../../../Constants/Constants";
import { disabledListData, DisableTreeData } from "../../../Data/BonusUi/Tree";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const DisabledSortableList = () => {
  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (listRef.current) {
      Sortable.create(listRef.current, {
        disabled: true,
        animation: 150,
      });
    }
  }, []);

  return (
    <Col lg="4">
      <Card>
        <CommonCardHeader title={DisabledLists} span={DisableTreeData} />
        <CardBody>
          <ul className='list-group' id='disable-list' ref={listRef}>
            {disabledListData.map((item) => (
              <LI key={item.id}>{item.content}</LI>
            ))}
          </ul>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DisabledSortableList;
